import { ReactSortable } from "react-sortablejs";
import { Course, sendPostReq } from "../../Scripts/misc";
import SignedUpCourseCard from "./SignedUpCourseCard";
import SignOutModals from "./SignOutModals";
import { useEffect, useState } from "react";

interface Props {
    signedUpCourses: Course[]
    token: string
}

function SignedInSection({signedUpCourses, token}: Props) {

    let [courses, setCourses] = useState(signedUpCourses)
    let [err, setErr] = useState("")

    const getUserCourseOrder = async () => {
        let res = await sendPostReq("/api/getMySignedInCourses", {"token": token})

        if (res instanceof Array) {processUserOrder(res)}
        
        return
    }

    const processUserOrder = (order: number[]) => {
        let temp = courses
        temp.sort((a,b) => order.indexOf(a.id) - order.indexOf(b.id))
        console.log(order)
        setCourses(temp)
    }

    const saveCourseOrder = async () => {
        let order = courses.map(c => c.id)
        console.log(order)

        let res = await sendPostReq("/api/saveSort", {"token": token, "order": order.toString()})

        setErr("Pořadí se úspěšně uložilo")
        setTimeout(() => {setErr("")},2000)
    }

    useEffect(() => {
        getUserCourseOrder()
    },[])

    return ( <>

{signedUpCourses.length && <>

{signedUpCourses.map(c => <SignOutModals course={c}/>)}

<div className="right-panel" style={{marginLeft: "2vw"}}>
    <h4>Přihlášené kroužky</h4>
    <div id="registeredClubs">
        <ReactSortable list={courses} setList={setCourses}>
            {courses.map(c => <SignedUpCourseCard course={c} token={token}/>)}
        </ReactSortable>
    </div>
    <button className="btn btn-primary" onClick={saveCourseOrder}>Uložit pořadí</button>
    <p style={{marginTop: "2vh", textAlign: "center"}}>{err}</p>
</div>

</>
}

    </> );
}

export default SignedInSection;